/**
 * @param {HTMLElement} dropdown
 */
export function dropdownOutsideContainer(dropdown) {
    const parent = dropdown.parentElement

    $(dropdown).on('show.bs.dropdown', function() {
        const offset = $(dropdown).offset()
        dropdown.style.position = 'absolute'
        dropdown.style.left = `${offset.left}px`
        dropdown.style.top = `${offset.top}px`
        document.body.append(dropdown)
    })

    $(dropdown).on('hidden.bs.dropdown', function() {
        dropdown.style.removeProperty('position')
        dropdown.style.removeProperty('left')
        dropdown.style.removeProperty('top')
        parent.append(dropdown)
    });
}
